module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copy":"Copy link","share":"Share link","linkCopied":"Link copied","shareDescription":"Check out this selection of jobs at {companyName}","shareTitle":"Selection of jobs at {companyName}"}}')
  delete Component.options._Ctor
}
